var HELP_EVENT_TYPES = /* @__PURE__ */ ((HELP_EVENT_TYPES2) => {
  HELP_EVENT_TYPES2["FlightControlGetTime"] = "Help_Flight_Control_Get_Time";
  HELP_EVENT_TYPES2["TicketCreationTime"] = "Help_Ticket_Creation_Time";
  HELP_EVENT_TYPES2["ManagementGroupsLoadTime"] = "Help_Management_Groups_Load_Time";
  HELP_EVENT_TYPES2["FlightGetTime"] = "Help_Flight_Get_Time";
  HELP_EVENT_TYPES2["FlightDeleteTime"] = "Help_Flight_Delete_Time";
  HELP_EVENT_TYPES2["ChangeManagementGroupTime"] = "Help_Change_Management_Group_Time";
  HELP_EVENT_TYPES2["FlightControlValue"] = "Help_Flight_Control_Value";
  return HELP_EVENT_TYPES2;
})(HELP_EVENT_TYPES || {});
export {
  HELP_EVENT_TYPES
};
//# sourceMappingURL=constants.js.map
